import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi.js'

const questionsApi = createApi({
    reducerPath: 'questionsApi',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    endpoints: (builder) => ({
        getQuestions: builder.query({
            query: () => ({
                url: '/back/faq/list',
                method: 'POST',
            }),
        }),
        getOrderByQuery: builder.mutation({
            query: (q) => ({
                url: '/cms/index.php?route=module/isearch/ajaxget&k=' + q,
                method: 'POST',
            }),
        }),
        sendForm: builder.mutation({
            query: (body) => ({
                url: '/back/faq/add',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: {
                    name: body.name,
                    email: body.email,
                    product_id: body.orderName,
                    text: body.question,
                },
            }),
        }),
    }),
})
export default questionsApi
